export default theme => ({
  linkWithIcon: {
    display: "inline-block",
    whiteSpace: "nowrap",
  },
  linkWithIcon_text: {
    display: "inline-block",
    whiteSpace: "pre-wrap",
  },
  linkWithIcon_icon: {
    marginRight: 5,
    display: "inline-block",
    verticalAlign: "middle",
  },
  linkWithIcon_link: {
    color: theme.palette.link.dark,
    cursor: "pointer",
  },
  linkWithIcon_chip: {
    cursor: "pointer",
  },
});
